export default __webpack_public_path__ + "static/gb-sct-2b290d929f822fe55354121942bfbc29.svg";